module.exports = __webpack_public_path__ + "static/media/app-store-fr.2cfdd0a7.svg";